
export default function LineSeparator() {
    return (
        <div className="my-6 h-px bg-gradient-to-r from-[#00F0FF] via-transparent to-[#FF007F] opacity-30"></div>
    )
}

